import { LeaderItem } from "./interface"
export const data: Array<LeaderItem> = [{
  img: require('@/assets/images/leader/ljh.jpg'),
  name: "郎景和",
  title: [
    "中国工程院院士，中国医学科学院中国协和医科大学北京",
    "协和医院妇产科主任，《中国病案》杂志编委会名誉主任"
  ]
}, {
  img: require('@/assets/images/leader/mjr.jpg'),
  name: "马家润",
  title: [
    "（原）北京协和医院病案科副主任",
    "（原）北京医学会理事及病案管理委员会主任委员",
    "（原）中华医院管理学会理事",
    "（原）病案管理专业委员会副主任委员",
    "（原）《中国病案》杂志社副总编",
  ]
}, {
  img: require('@/assets/images/leader/hys.jpg'),
  name: "胡燕生",
  title: [
    "（原）首都医科大学附属北京朝阳医院医务处长",
    "门诊部副主任兼病案统计科主任",
    "中国医院协会病案专业委员会主任委员",
    "中国医院协会常务理事",
    "《中国病案》杂志社社长",
    "（原）首都医科大学附属北京朝阳医院河北燕达院区医疗院长",
    "（原）北京市卫生局病案质量控制与改进中心主任",
  ]
},{
  img:require('@/assets/images/leader/ly.jpg'),
  name:"鲁杨",
  title:"首都医科大学燕京医学院信息管理与信息系统专业副教授、疾病分类学教师"
}]